export const baseUrl = (path, domain) => {
  const url = `${process.env.WIDGET_BASE_URL}${path}`
  return domain ? url.replace('://', `://${domain}.`) : url
}

export const jobUrl = (id, domain) => baseUrl(`/jobs/${id}?widget=true`, domain)



// WEBPACK FOOTER //
// ./src/helpers/url.js